import { MapLayerCategory } from "../../../utils/layer-registry";
import { darkenColor } from "./BaseMapDialogHelpers";

export class LineSourceHelper {
  static toggle(src: string, isActive: boolean, minZoom: number, color?: string) {
    if (!window.map || !window.layerRegistry || !window.user) {
      console.error('LineSourceHelper.toggle ➜ map, registry, or user missing');
      return;
    }

    const layerId = src; // main coloured stroke
    const borderId = `${src}-border`;
    const namesId = `${src}-names`;

    if (isActive) {
      const sourceSpec = this.buildVectorSourceSpec(src, minZoom);
      const strokeColor = color || '#000000';
      const haloColor = darkenColor(strokeColor);

      // Main line (z:1)
      window.layerRegistry.addLayer(
        {
          id: layerId,
          type: 'line',
          source: src,
          'source-layer': 'data',
          layout: { 'line-join': 'round', 'line-cap': 'round' },
          paint: {
            'line-color': strokeColor,
            'line-width': ['interpolate', ['linear'], ['zoom'], 0, 1, 14, 4]
          }
        },
        MapLayerCategory.Annotations,
        {
          z: 1,
          // @ts-ignore
          source: { id: src, spec: sourceSpec }
        }
      );

      // Halo (z:0)
      window.layerRegistry.addLayer(
        {
          id: borderId,
          type: 'line',
          source: src,
          'source-layer': 'data',
          layout: { 'line-join': 'round', 'line-cap': 'round' },
          paint: {
            'line-color': haloColor,
            'line-width': 6
          }
        },
        MapLayerCategory.Annotations,
        { z: 0 }
      );

      // Trail names (z:2)
      window.layerRegistry.addLayer(
        {
          id: namesId,
          type: 'symbol',
          source: src,
          'source-layer': 'data',
          minzoom: 9,
          layout: {
            'symbol-placement': 'line',
            'text-field': ['get', 'title'],
            'text-font': ['Open Sans Regular', 'Arial Unicode MS Regular'],
            'text-size': 12,
            'text-allow-overlap': false,
            'symbol-spacing': 250,
            'text-max-angle': 30,
            'text-pitch-alignment': 'map',
            'text-ignore-placement': false
          },
          paint: {
            'text-color': '#333333',
            'text-halo-color': 'rgba(255, 255, 255, 0.8)',
            'text-halo-width': 1.5
          }
        },
        MapLayerCategory.Annotations,
        { z: 2 }
      );
    } else {
      // Remove in reverse-ish order; registry handles orphaned sources
      window.layerRegistry.removeLayer(borderId);
      window.layerRegistry.removeLayer(layerId);
      window.layerRegistry.removeLayer(namesId);
    }
  }

  private static buildVectorSourceSpec(src: string, minZoom: number) {
    const baseUrl = window.location.origin;
    const tilesUrl = `${baseUrl}/vector/${src}/{z}/{x}/{y}?public_filter=false&user_id=${window.user.id}&t=${Date.now()}`;
    return {
      type: 'vector' as const,
      tiles: [tilesUrl],
      minzoom: minZoom,
      maxzoom: 14
    };
  }
}

